import useSWR from 'swr'
import { get } from '@/utils/request'

// 全平台推广条 —— 由后台「广告(推广)」控制:取 ad_type>=100 且 enabled 的推广位,
// Admin 在广告后台一键开/关(enabled)即可全平台上/撤。默认文案指向乌节杯 /wujie。
type PromoAd = { id: string; title?: string; link?: string; enabled?: boolean; data?: { subtitle?: string } }

export const useActivePromotion = (): PromoAd | null => {
  const { data } = useSWR<PromoAd[]>(
    'ads-promotions',
    () => get('ads/promotions').then((r) => (r.ok ? (r.data as PromoAd[]) : [])),
    { revalidateOnFocus: false, refreshInterval: 300000, fallbackData: [] }
  )
  return (data || []).find((a) => a.enabled && a.link) || null
}

const WujiePromoBar = ({ className = '' }: { className?: string }) => {
  const promo = useActivePromotion()
  if (!promo) return null
  const title = promo.title || '「乌节杯」企业家智力大赛 · 8.8 杭州'
  const subtitle = promo.data?.subtitle || '掼蛋团团转 · 冠军奖金 8888 元 + 王茅·储50 木盒'
  const href = promo.link || '/wujie'
  return (
    <a
      href={href}
      className={`group flex items-center justify-between gap-3 overflow-hidden rounded-xl px-4 py-3 shadow-lg ${className}`}
      style={{ background: 'linear-gradient(120deg, #181410 0%, #3a1416 55%, #DB3142 130%)' }}
    >
      <div className="min-w-0 text-white">
        <div className="flex items-center gap-2">
          <span className="shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold" style={{ background: '#EAB13B', color: '#181410' }}>
            重磅赛事
          </span>
          <span className="truncate text-sm font-bold">{title}</span>
        </div>
        <div className="mt-0.5 truncate text-xs text-white/70">{subtitle}</div>
      </div>
      <span
        className="shrink-0 rounded-full px-4 py-1.5 text-xs font-bold transition group-active:scale-95"
        style={{ background: '#EAB13B', color: '#181410' }}
      >
        立即了解
      </span>
    </a>
  )
}

export default WujiePromoBar
